import { RegularButton } from 'fronton-react';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getLang } from 'utils';
import { PDP_REVIEWS_ADD_NEW_CLICK } from '../../actions';
import { getIsClientVerificationPending } from 'features/client-verification/ducks/selectors';
import { VERIFY_CLIENT } from 'features/client-verification/ducks/client-verification';
import { ClientRenderedRemote } from '@okapi/remote';
import { getIsReviewFormRemoteEnabled } from 'common/selectors/env';
import { getProductId } from 'features/product-info';
import { getInitUrl } from 'features/page-model';
import { getRegionCode } from 'common/selectors';

type PdpReviewsAddNewProps = { wide?: boolean } & React.HTMLAttributes<HTMLElement>;

export const PdpReviewsAddNew: React.FC<PdpReviewsAddNewProps> = ({ wide, ...props }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isReviewFormRemoteEnabled = useSelector(getIsReviewFormRemoteEnabled);
  const isPending = useSelector(getIsClientVerificationPending);
  const productId = useSelector(getProductId) || '';
  const authFallbackUrl = useSelector(getInitUrl) || '';
  const regionCode = useSelector(getRegionCode);
  const lang = getLang();

  const handleClick: React.MouseEventHandler<HTMLButtonElement> = () => {
    if (isPending) return;

    dispatch(PDP_REVIEWS_ADD_NEW_CLICK());
    dispatch(VERIFY_CLIENT());
  };

  if (isReviewFormRemoteEnabled) {
    return (
      <div {...props}>
        <ClientRenderedRemote
          widget="review-form/review-form"
          data={{
            button: {
              size: 'l',
              wide,
            },
            analytics: {
              elementBlock: 'reviewsBlock',
              elementVariant: 'pdp',
            },
            productId,
            lang,
            regionCode,
            authFallbackUrl,
          }}
          id="review-form"
        />
      </div>
    );
  }

  return (
    <div {...props}>
      <RegularButton loading={isPending} onClick={handleClick} size="l" variant="primary" wide={wide}>
        {t('reviews.form.ui.write-review')}
      </RegularButton>
    </div>
  );
};
